var _path, _path2, _path3, _rect, _g, _path4, _path5, _rect2, _g2, _rect3, _g3, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrape(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 280,
    viewBox: "0 0 280 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140 275C65.4 275 5 214.6 5 140C5 65.4 65.4 5 140 5C214.6 5 275 65.4 275 140C275 214.6 214.6 275 140 275Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119.123 182.136L111.15 182.797L114.288 220.667L122.261 220.007L119.123 182.136Z",
    fill: "#3A3A3A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M163.7 182.4H155.7V220.4H163.7V182.4Z",
    fill: "#3A3A3A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_129",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 95,
    y: 233,
    width: 90,
    height: 15
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 233,
    width: 90,
    height: 15,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.2 245.4C163.672 245.4 182.7 243.161 182.7 240.4C182.7 237.639 163.672 235.4 140.2 235.4C116.728 235.4 97.7 237.639 97.7 240.4C97.7 243.161 116.728 245.4 140.2 245.4Z",
    fill: "#BFC3CE"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M110.2 238.4C119.865 238.4 127.7 233.475 127.7 227.4C127.7 221.325 119.865 216.4 110.2 216.4C100.535 216.4 92.7 221.325 92.7 227.4C92.7 233.475 100.535 238.4 110.2 238.4Z",
    fill: "#3A3A3A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M168.2 238.4C177.865 238.4 185.7 233.475 185.7 227.4C185.7 221.325 177.865 216.4 168.2 216.4C158.535 216.4 150.7 221.325 150.7 227.4C150.7 233.475 158.535 238.4 168.2 238.4Z",
    fill: "#3A3A3A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_129",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 95,
    y: 220,
    width: 10,
    height: 10
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 220,
    width: 10,
    height: 10,
    fill: "url(#pattern1)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.2 227.4C101.581 227.4 102.7 226.281 102.7 224.9C102.7 223.519 101.581 222.4 100.2 222.4C98.8193 222.4 97.7 223.519 97.7 224.9C97.7 226.281 98.8193 227.4 100.2 227.4Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1_129",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 174,
    y: 220,
    width: 10,
    height: 10
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 220,
    width: 10,
    height: 10,
    fill: "url(#pattern2)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1_129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.2 227.4C180.581 227.4 181.7 226.281 181.7 224.9C181.7 223.519 180.581 222.4 179.2 222.4C177.819 222.4 176.7 223.519 176.7 224.9C176.7 226.281 177.819 227.4 179.2 227.4Z",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2 129.3L92.9 136.5C92.8 139 90.7 140.9 88.2 140.8C85.7 140.7 83.8 138.6 83.9 136.1L84.2 128.9C84.3 126.4 86.4 124.5 88.9 124.6C91.3 124.8 93.3 126.8 93.2 129.3Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M107.7 95.2C107.7 96.7 107.1 98 106.2 99C105.8 99.3 105.5 99.5 105.2 99.8C100.9 103.6 97.8 108.8 96.7 114.7C96.6 115 96.6 115.3 96.5 115.6C95.9 117.9 93.7 119.6 91.2 119.6C88.4 119.6 86.2 117.6 85.8 115C85.8 114.6 85.7 114.2 85.7 113.8C85.7 113.6 85.7 113.3 85.7 113.1C85.7 103.5 91 95.1 99 90.6C99.4 90.4 99.8 90.1 100.3 89.9C100.9 89.7 101.6 89.5 102.2 89.5C105.3 89.7 107.7 92.1 107.7 95.2Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4 130.2C73.4 130.2 53.7 160.5 62.2 182.4",
    stroke: "#3A3A3A",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M134.4 204.9C174.164 204.9 206.4 166.799 206.4 119.8C206.4 72.8006 174.164 34.7 134.4 34.7C94.6355 34.7 62.4 72.8006 62.4 119.8C62.4 166.799 94.6355 204.9 134.4 204.9Z",
    fill: "#9CCD65"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M205.4 119.9C205.4 166.6 173.2 204.5 133.4 204.5C131.3 204.5 129.1 204.4 127 204.2C156.2 195.9 178.4 153.7 178.4 102.9C178.4 81.7 174.5 62 167.9 45.7C190.2 60 205.4 87.9 205.4 119.9Z",
    fill: "#8BAE5D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M191.1 144.7C191.1 144.7 211.1 131.7 208.1 111.7C208.1 111.7 215.1 101.7 211.1 92.7",
    stroke: "#3A3A3A",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M199.1 103.7C199.1 103.7 201.1 113.7 208.1 111.7C215.1 109.7 221.3 106.7 219.7 97.2",
    stroke: "#3A3A3A",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M113.3 132.6C116.89 132.6 119.8 129.69 119.8 126.1C119.8 122.51 116.89 119.6 113.3 119.6C109.71 119.6 106.8 122.51 106.8 126.1C106.8 129.69 109.71 132.6 113.3 132.6Z",
    fill: "#4C1A1D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M155.3 132.6C158.89 132.6 161.8 129.69 161.8 126.1C161.8 122.51 158.89 119.6 155.3 119.6C151.71 119.6 148.8 122.51 148.8 126.1C148.8 129.69 151.71 132.6 155.3 132.6Z",
    fill: "#4C1A1D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M146.3 132.6C146.3 138.7 141.4 143.6 135.3 143.6C129.2 143.6 124.3 138.7 124.3 132.6",
    fill: "#4C1A1D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_129",
    transform: "scale(0.0111111 0.0666667)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_1_129",
    transform: "scale(0.1)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_1_129",
    transform: "scale(0.1)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1_129",
    width: 90,
    height: 15,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEASABIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMAEAMCAwYAAAGmAAACAwAAAs7/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoXHh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoaJjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAA8AWgMBIgACEQEDEQH/xACJAAADAQEBAAAAAAAAAAAAAAAABAUGAwIBAQAAAAAAAAAAAAAAAAAAAAAQAAAGAgMBAAAAAAAAAAAAAAACAwQFBgEHIBYXEBEAAQIDBAcGBwAAAAAAAAAAAQACEQMEITHREkGRoZKTBTUQUbET0xSBMkJSYmMkEgEAAAAAAAAAAAAAAAAAAAAg/9oADAMBAAIRAxEAAADF6nJ6QrPT+40AAcDwkwkQo1aSf//aAAgBAgABBQDl/9oACAEDAAEFAOX/2gAIAQEAAQUAj4t1IHZ62dqjGsEAXW8LjHnEGPOIMecQY84hA41kyMd1rJYpZOryEd8ZHfkUazN6STJarmXCFttWD9vmR2+ZHb5kOLdZM47Xcg6sF6VNJObCvkf/2gAIAQICBj8AX//aAAgBAwIGPwBf/9oACAEBAQY/AAyQABGBJKDp9QGyyPpFu2Ktq36hggHOeTpOY4q9+8cVe/eOKvfvHFXv3jioyah8tv22HxBUaaqidOcA2fCCcXlr2NESRYdXZmofML/1gu2AFNbKpKiY0XE08wx1BAHktQ49/kzfTX9HI6ks/GTMJ2sC6DXcB+C6DXcB+C6DXcB+CHtuRVYOnPJmDwaV0So4M301FvLqiUyHy+3mnblCca5k9jTe10tzANY7P//Z"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_1_129",
    width: 10,
    height: 10,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEASABIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMAEAMCAwYAAAF0AAABgwAAAa7/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoXHh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoaJjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAAoACgMBIgACEQEDEQH/xABoAAEBAQAAAAAAAAAAAAAAAAAABQYBAQAAAAAAAAAAAAAAAAAAAAAQAQEBAQAAAAAAAAAAAAAAAAUAEAQRAAIBBQAAAAAAAAAAAAAAABIEESABITECEgEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAAACNmA//2gAIAQIAAQUAv//aAAgBAwABBQC//9oACAEBAAEFABBAusLf/9oACAECAgY/AH//2gAIAQMCBj8Af//aAAgBAQEGPwBhxxgGuCixQMaxR//Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrape);
export default __webpack_public_path__ + "static/media/grape.f0739bcfd6774a02c6cd3383080f8fa4.svg";
export { ForwardRef as ReactComponent };